import React from "react";
import { Card, Row, Col, Image } from "antd";
import { addCartCoupons, cartCouponSelector } from "../../../api/cartSlice";
import PButton from "./payment";
import styled from "styled-components";
import { loginSelector } from "../../../api/authSlice";
import { useSelector } from "react-redux";
import Fade from "react-reveal/Fade";
import { Link } from "react-router-dom";
import Loader from "../../../shared/loader";
import { MdCardGiftcard } from "react-icons/md";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay, Pagination } from 'swiper';

const { Meta } = Card;

export default function Product({ data }) {
  const { curr_user } = useSelector(loginSelector);

  return (
    // <ProductWrap className="container py-sm-3">
    <Row gutter={30} className=' border-white md:h-80 h-[240px] '>
        <Swiper 
        slidesPerView={1}
        spaceBetween={10}
        loop={true}
        loopFillGroupWithBlank={true}
        grabCursor={true}
        autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
        pagination={{
          clickable: true,
        }}
        breakpoints={{
          "@0.00": {
            slidesPerView: 1,
            spaceBetween: 10,
          },
          "@0.75": {
            slidesPerView: 1,
            spaceBetween: 10,
          },
          "@1.00": {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          "@1.50": {
            slidesPerView: 4,
            spaceBetween: 30,
          },
        }}
        modules={[Pagination, Autoplay]}
        className="mySwiper"
      >
      {data.map((item, i) => {
        return (
            <SwiperSlide>
          <div className="my-3 md:w-[255px] w-[310px]  md:mx-6 mx-6  border-white rounded-3xl  z-80 md:shadow-2xl shadow-xl">
            <Fade duration={2000}>
              <Link to={`/products/${item._id}`}>
                <div >
                  {/* // cover={<img alt="example" style={{height:"250px"}} src={`https://sycamoredev.herokuapp.com/static/${item.image}`} />} */}

                  {item?.image ? (
                    <img
                      src={item?.image}
                      className="md:my-[24px] my-[4px] h-[140px]  object-cover w-full "
                      alt="imglogo"
                    />
                  ) : (
                    <span
                      className="md:my-[24px] my-[4px] md:h-[140px] h-[80px] object-cover w-full "
                    >
                      <MdCardGiftcard className="voucher text-center" />
                      &nbsp;
                    </span>
                  )}

                  {/* <hr/> */}

                  <h6
                    className="bg-[#9a4c9d] text-center rounded-b-3xl   text-white md:pt-1 pt-3 mb-0 text-[14px]  md:h-12 h-12 "
                  >
                    {item.name}
                  </h6>

                  {/* <PButton size="small"  type="primary" productId={item._id} total={item.price} user={curr_user} title={item.title}>shop</PButton>   */}
                </div>
              </Link>
            </Fade>
          </div>
          </SwiperSlide>
        );
      })}
      </Swiper>
    </Row>

    // </ProductWrap>
  );
}

const ProductWrap = styled.div`
  hr {
    height: 2px;
    border-bottom: 2px solid white;
    /* border-style:dashed; */
    margin: 0.5rem auto;
  }

  .load {
    text-align: center;
    margin: auto;
    display: block;
  }

  .voucher {
    color: orange;
    font-size: 5rem;
  }
`;
